<script>
    import { fly } from "svelte/transition";
    import { KeyPad, Button, IdPad, ProvincePad, Input } from "../index";
    let show = false;
    let show1 = false;
    let show2 = false;
    let val = "";
    let val1 = "";
    let val2 = "";
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <Button on:click={() => (show = !show)}>键盘</Button>
        <KeyPad {show} bind:value={val} on:submit={()=>(show = !show)} />
        <Input value={val} placeholder="请输入" />
    </div>

    <h4 class="example-title">身份证号码键盘</h4>
    <div class="example-body">
        <Button on:click={() => (show1 = !show1)}>身份证号码键盘</Button>
        <Input value={val1} placeholder="请输入" />
        <IdPad show={show1} bind:value={val1} on:submit={()=>(show1 = !show1)} />
    </div>

    <h4 class="example-title">省简称选择器</h4>
    <div class="example-body">
        <Button on:click={() => (show2 = !show2)}>省简称选择器</Button>
        <Input value={val2} placeholder="请输入" />
        <ProvincePad
            show={show2}
            bind:value={val2}
            on:submit={()=>(show2 = !show2)}
        />
    </div>
</div>

<style lang="less">
    @import "./example.less";
</style>
